import React from 'react'
import { CCard } from '@coreui/react'
import '../../../../components/artistModal/artistModal.scss'
import Video1 from 'src/assets/Content-Icons/PNGs/video-icon.png'
import Audio1 from 'src/assets/Content-Icons/PNGs/audio-icon.png'
import { useHistory } from 'react-router-dom'
import { raiseToast } from '../../../utils/helper'

const CampaignChooseTemplate = () => {
  const imgSize = {
    height: '5.4vw',
    width: '5.4vw',
  }
  const history = useHistory()
  const pickTemplate = (value) => {
    if (value === 'Mail') {
      history.push('/campaign/mail-templates/list')
    } else {
      raiseToast('warn', 'Work under progress')
    }
  }

  return (
    <div
      className="mb-5 d-flex justify-content-center align-middle"
      style={{ marginTop: '10.5rem', gap: '0 6.5rem' }}
    >
      <CCard
        style={{
          textAlign: 'center',
          width: '100%',
          paddingTop: '1.5rem',
          paddingBottom: '3.5rem',
        }}
        className={'hover-semibold hover-shadow'}
      >
        <div
          className=" d-flex flex-column justify-content-center align-items-center p-3 rounded-3 "
          role="button"
          onClick={() => pickTemplate('Mail')}
        >
          <img
            src={Video1}
            alt=""
            style={{
              ...imgSize,
            }}
          />
          <span
            style={{ fontSize: '19px', fontWeight: 'inherit', paddingTop: '1rem' }}
            className="mt-3"
          >
            MAIL
          </span>
        </div>
      </CCard>
      <CCard
        style={{
          textAlign: 'center',
          width: '100%',
          paddingTop: '1.5rem',
          paddingBottom: '3.5rem',
        }}
        className={'hover-semibold hover-shadow'}
      >
        <div
          className=" d-flex flex-column justify-content-center align-items-center p-3 rounded-3"
          role="button"
          onClick={() => pickTemplate('Social')}
        >
          <img
            src={Audio1}
            alt=""
            style={{
              ...imgSize,
            }}
          />
          <span
            style={{ fontSize: '19px', fontWeight: 'inherit', paddingTop: '1rem' }}
            className="mt-3"
          >
            Social Media
          </span>
        </div>
      </CCard>
      <CCard
        style={{
          textAlign: 'center',
          width: '100%',
          paddingTop: '1.5rem',
          paddingBottom: '3.5rem',
        }}
        className={'hover-semibold hover-shadow'}
      >
        <div
          className=" d-flex flex-column justify-content-center align-items-center p-3 rounded-3"
          role="button"
          onClick={() => pickTemplate('Social')}
        >
          <img
            src={Audio1}
            alt=""
            style={{
              ...imgSize,
            }}
          />
          <span
            style={{ fontSize: '19px', fontWeight: 'inherit', paddingTop: '1rem' }}
            className="mt-3"
          >
            SMS Template
          </span>
        </div>
      </CCard>
    </div>
  )
}

export default CampaignChooseTemplate
